<template>
    <div class="login" @keyup.enter="Login">
      <el-card class="signBox" >
        <div class="title">门店检查管理平台</div>
        <el-form
          class="demo-ruleForm"
          v-bind:model="ruleForm"
          status-icon=""
          v-bind:rules="rules"
          ref="form"
          label-width="0px"
        >
          <el-form-item label="" prop="cellphone">
            <span>{{ $t('login.userName') }}</span>
            <el-input
              type="text"
              v-model="ruleForm.cellphone"
              autocomplete="off"
              :placeholder="$t('login.enterName')"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <span>{{ $t('login.password') }}</span>
            <el-input
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
              :placeholder="$t('login.enterPassword')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="success"
              style="width: 100%; margin-top: 20px"
              @click="Login"
            >
              {{ $t('login.login') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="footer">欢迎使用门店检查管理平台</div>
    </div>
  </template>

  <script>

  import md5 from "md5";

  export default {
    name: 'Login',
    data () {
      const validateCellphone = (rule, value, callback) => {
        if (value) callback()
        else callback(new Error(this.$t('login.enterName') + '!'))
      }

      const validatePassword = (rule, value, callback) => {
        if (value) callback()
        else callback(new Error(this.$t('login.enterPassword') + '!'))
      }

      let cellphone = ''

      return {
        ruleForm: { cellphone, password: '' },
        rules: {
          cellphone: [{ validator: validateCellphone, trigger: 'blur' }],
          password: [{ validator: validatePassword, trigger: 'blur' }]
        }
      }
    },
    mounted(){
      // console.log(this.$router.options.routes.filter(i=>i.path==='/')[0].children.filter(i=>i.name))
    },
    methods: {
      getFirstMenuKey (menu) {
        if (menu.hasSubMenu) {
          return menu.subMenuList[0].url + '-' + menu.subMenuList[0].menuCode
        } else {
          return menu.url + '-' + menu.menuCode
        }
      },
      async Login () {
        const params = {
          "appName": "top_door",
          "cellphone": this.ruleForm.cellphone,
          "password": md5(this.ruleForm.password),
          "platform": "H5"
        }
        let res = await window.instance.post(window.retailinkUrl + '/accounts/login', params)
        if (res.data.code === 200) {
          res = res.data.data
          const account = res.account
          const menuList = res.menuList
          console.log('menuList', menuList)
          if (!menuList || !menuList.length) {
            this.$message.error('没有配置菜单权限');
            return false;
          } else {
            console.log('data.data.menuList', menuList)
            // todo: 保存每个mune的menuCode,后面可能会用到,暂时没用
            let menuMap = {};
            _.each(menuList, (menu)=>{
              menuMap[menu.url] = menu.menuCode;
              if(menu.hasSubMenu){
                _.each(menu.subMenuList, (subMenu=>{
                  menuMap[subMenu.url] = subMenu.menuCode;
                }))
              }
            })
            // 保存每个mune的title,在页面上显示
            let menuTitleMap = {};
            _.each(menuList, (menu)=>{
              menuTitleMap[menu.url] = menu.menuName;
              if(menu.hasSubMenu){
                _.each(menu.subMenuList, (subMenu=>{
                  menuTitleMap[subMenu.url] = subMenu.menuName;
                }))
              }
            })
            localStorage.setItem("retailogMenus", JSON.stringify(menuList))
            localStorage.setItem("retailogMenuMap", JSON.stringify(menuMap))
            localStorage.setItem("retailogMenuTitleMap", JSON.stringify(menuTitleMap))
            const indexMenu = this.getFirstMenuKey(menuList[0])
            console.log('getFirstMenuKey', indexMenu)
            this.$store.commit("setToken", res.token);
            this.$store.commit("setAccount", account.cellphone);
            this.$store.commit("setAvatar", account.imageUrl);
            this.$store.commit("setRoleCode", account.roleCode);
            localStorage.setItem("userName", account.name);
            localStorage.setItem("account", account.account);
            localStorage.setItem("avatar", account.imageUrl);
            let [menuKey, menuCode] = indexMenu.split('-');
            this.$router.push({path: menuKey, query: { menuCode: menuCode }});
          }
        }
      }
    }
  }
  </script>

  <style scoped lang="scss">
  .login {
    height: 100vh;
    width: 100vw;
    background: #EEEEEE;
    overflow: hidden;
    .topBar{
      display: flex;
      height: 40px;
      padding: 15px;
      align-items: center;
      flex-direction: row-reverse;
    }
    .signBox{
      width: 360px;
      padding: 20px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .title{
        color: #6F6F6F;
        font-size: 26px;
        font-weight: 600;
        letter-spacing: 2px;
        text-align: center;
        margin-bottom: 30px;
      }
    }
    .footer{
      position: absolute;
      bottom: 30px;
      width: 100%;
      font-size: 14px;
      text-align: center;
    }

  }
  </style>



// WEBPACK FOOTER //
// src/topdoor/pages/login.vue